// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"e803c6fc","547":"24c94812","565":"5a30823d","576":"cc9294fa","839":"ddbe4a57","982":"6980cc5f"}[chunkId] + ".chunk.css";
};